import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../theme';
import CdnImage from '../../../CdnImage/CdnImage';
const EmptyPage = ({ title, description }) => {
    const { t } = useTranslation('Account');
    const { EmptyPage: css } = useTheme('Account');
    return (React.createElement("div", { className: css.root },
        React.createElement("div", { className: css.header },
            React.createElement(CdnImage, { path: "https://cdn.websky.aero/content/frontend/images/emojy/sorry.svg" }),
            React.createElement("div", { className: css.title }, title || t('Sorry'))),
        description && React.createElement("div", { className: css.description }, description)));
};
export default EmptyPage;
